import React from 'react';
import Section from '@components/Section';
import Colors from './Form/Colors';

export default function ColorSelect({ onSelect, color }) {
  return (
    <Section>
      <Section.Title underline>Color</Section.Title>
      <Colors active={color} onSelect={onSelect} />
    </Section>
  );
}
